module.exports = {
  'title': 'Logiciel d\'architecture BoA',
  'navBoaSoftware': 'Logiciel BoA',
  'navPresentation': 'Présentation',
  'navCharacteristics': 'Caractéristiques',
  'navCompatibility': 'Compatibilité',
  'navDownloads': 'Téléchargements',
  'navPricing': 'Tarifs',
  'navVersions': 'Versions',
  'navNumbering': 'Numérotation',
  'navBoA-4_2': 'BoA 4.2',
  'nav4_2-4_3': '4.2 → 4.3',
  'navBoA-4_3': 'BoA 4.3',
  'navBoA-4_3Localized': 'BoA 4.3 localisé',
  'navBoA-4_4': 'BoA 4.4',
  'navDocumentation': 'Documentation',
  'navManuals': 'Manuels',
  'navTutorials': 'Tutoriels',
  'navImages': 'Images',
  'navHatching': 'Hachures',
  'navContact': 'Contact',
  'navForum': 'Forum',
  'navLinks': 'Liens'
};
